import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import OriginalGoodsItem from '../../components/store/OriginalGoodsItem';

class OriginalGoods extends PureComponent {
  state = {};
  _isLoad = false;
  componentDidMount = () => {
    this._isLoad = true;
    this._getData(1);
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };
  _getData = async (gotoPage) => {
    // const { pageSize } = this.state;
    // const { match, location } = this.props;
    const result = await this._getApi(1, 100);
    const intReturn = result.data[0].intReturn;
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const originalList = result.data[0].listData;

    if (intReturn === 0) {
      if (con > 0) {
        if (this._isLoad) {
          this.setState({
            originalList: originalList,
            gotoPage: gotoPage,
            con: con,
            pageCount: pageCount,
          });
        }
      }
    }
  };

  _getApi = (gotoPage, pageSize) => {
    const { apiUrl } = this.props;

    return axios(
      apiUrl +
        '/getOriginalGoods?gotoPage=' +
        gotoPage +
        '&pageSize=' +
        pageSize
    )
      .then((response) => response)
      .catch((error) => {
        alert(
          '네트워크 오류: 뽑기왕 데이터를 로드 하는 중 오류가 발생했습니다.'
        );
      });
  };

  _renderItem = () => {
    const { originalList } = this.state;

    const list = originalList.map((item, index) => {
      return (
        <OriginalGoodsItem
          key={index}
          index={index}
          ichSerial={item.ichSerial}
          saleActive={item.saleActive}
          listImg={item.listImg}
          title={item.title}
          subTitle={item.subTitle}
        />
      );
    });

    return list;
  };
  render() {
    const { originalList, con } = this.state;
    return (
      <Fragment>
        <div className="store_orgin" id="original_goods">
          {/* 오리지널 굿즈 상단 */}
          <div className="store_orgin_top">
            <h3>
              <span className="tag">오리지널 굿즈</span>{' '}
              <strong className="num">총 {con}개</strong>
            </h3>
            <ul className="store_orgin_rt">
              <li>
                오직 애니플러스에서만 만날 수 있는 애니플러스 오리지널 굿즈
                <em>!</em>
                <br />
                국내 최대 규모, 최고의 퀄리티, 애니플러스만이 가능한 노하우로
                고객님이 만족하시는 최고의 굿즈를 만듭니다.
              </li>
              <li>
                <img
                  src="../img/store/aniplus_orgin.png"
                  alt="ANIPLUS ORIGINAL GOODS"
                />
              </li>
            </ul>
          </div>
          {/* 오리지널 굿즈 컨테이너 */}
          <div className="store_orgin_container">
            {/* 오리지널 굿즈 리스트 */}
            <ul className="store_orgin_list">
              {originalList ? this._renderItem() : null}
            </ul>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(OriginalGoods)));
